import React, { useState, useEffect } from "react";
import axios from "axios";

import "./youtube.css";

export default function YoutubeComponent() {
  const [blogList, setblogList] = useState([]);
  const [loading, setLoading] = useState(1);

  //   useEffect(() => {
  //     axios
  //       .get(process.env.REACT_APP_BACKEND_URL + "/api/blog")
  //       .then((response) => {
  //         //console.log(response.data);
  //         setblogList(response.data);
  //         if (response.data.length > 0) {
  //           setLoading(1);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }, []);

  return (
    <div>
      {loading == 0 ? (
        <center>
          <div class="BlogNoDataDiv">
            <div
              class="spinner-border text-primary"
              role="status"
              style={{ height: "80px", width: "80px" }}
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </center>
      ) : (
        <div className="row BlogListRow">
          {/* Video One */}
          <div
            className="col-lg-4 col-md-6 YoutubeListCol"
            style={{
              marginTop: "8px",
              padding: "20px",
            }}
          >
            <h6>
              Learn the MERN Stack - Complete Application - Add Student (Part 3)
              🇱🇰
            </h6>
            <hr />
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/vUPK-hMKPwQ"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* Video One */}
          {/* Video Two */}
          <div
            className="col-lg-4 col-md-6 YoutubeListCol"
            style={{ marginTop: "8px", padding: "20px" }}
          >
            <h6>
              Learn the MERN Stack - Complete Application - Add Student (Part 3)
              🇱🇰
            </h6>
            <hr />
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/09O5JE5OEL0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* Video Two */}
          {/* Video Three */}
          <div
            className="col-lg-4 col-md-6 YoutubeListCol"
            style={{ marginTop: "8px", padding: "20px" }}
          >
            <h6>
              Learn the MERN Stack - Complete Application - Add Student (Part 1)
              🇱🇰
            </h6>
            <hr />
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/09O5JE5OEL0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* Video Three */}
          {/* Video Four */}
          <div
            className="col-lg-4 col-md-6 YoutubeListCol"
            style={{ marginTop: "8px", padding: "20px" }}
          >
            <h6>
              Learn the MERN Stack - Complete Application (MongoDB, Express,
              React, Node JS) - Part 1 🇱🇰 | Backend
            </h6>
            <hr />
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/LxUUXVpc-bY"
                allowfullscreen
              ></iframe>
            </div>
          </div>

          {/* Video Four */}
          {/* Video Five */}
          <div
            className="col-lg-4 col-md-6 YoutubeListCol"
            style={{ marginTop: "8px", padding: "20px" }}
          >
            <h6>HexaAuth | Face Authentication | Azure Face API</h6>
            <hr />
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/9iVBhRSLyq8"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* Video Five */}
          {/* Video Six */}
          <div
            className="col-lg-4 col-md-6 YoutubeListCol"
            style={{ marginTop: "8px", padding: "20px" }}
          >
            <h6>
              Convert Image to Text | Azure Optical Character Recognition (OCR)
            </h6>
            <hr />
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/hXexJI4Pfqk"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* Video Six */}
          {/* Video Seven */}
          <div
            className="col-lg-4 col-md-6 YoutubeListCol"
            style={{ marginTop: "8px", padding: "20px" }}
          >
            <h6>URL Shortener | MERN Stack</h6>
            <hr />
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/zzHRDCwJJSU"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* Video Seven */}
        </div>
      )}
    </div>
  );
}
